<template>
  <div id="app">
    <div class="bar">
      <div class="leftbar">
        <h1
          style="font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">
          Sketch Image Search App</h1>
      </div>
      <div class="rightbar">
        <img alt="Page logo" src="./assets/logo4.jpeg" style="width: 80px; height: auto;">
      </div>
    </div>
    <br>
    <vue-drawing-canvas ref="VueCanvasDrawing" v-model:image="image" :width="600" :height="400"
      :stroke-type="strokeType" :line-cap="lineCap" :line-join="lineJoin" :lineWidth="line" :color="color"
      :background-color="backgroundColor" :initial-image="initialImage" saveAs="png" :styles="{
      border: 'solid 1px #000',
    }" />
    <div class="button-container">
      <button type="button" @click.prevent="$refs.VueCanvasDrawing.undo()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
          class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z" />
          <path
            d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z" />
        </svg>
        Undo
      </button>
      <button type="button" @click.prevent="$refs.VueCanvasDrawing.redo()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise"
          viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
          <path
            d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
        </svg>
        Redo
      </button>
      <button type="button" @click.prevent="$refs.VueCanvasDrawing.reset()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark"
          viewBox="0 0 16 16">
          <path
            d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z" />
        </svg>
        Reset
      </button>
      
    </div>
    <div class="output">
    </div>
    <br><br>
    <br><br>
    
    <button @click="getSearchResults(image)">Confirm Sketch</button>
    <pulse-loader :loading="loading" style="margin-top: 2em;"></pulse-loader>
    <img v-if="isImageLoaded" :src="selectedImage" alt="Selected Image" />
    <div v-if="ButtonPress">
      <img :src="image" alt="Selected Image" style="max-width: 300px; margin-top: 20px;">
      <br>
      <p>Similar Images:</p>
      <ul class="image-list">
        <li v-for="filename in searchResults" :key="filename">
          <img :src="getImageUrl(filename)" alt="Similar Image" class="similar-image" />
        </li>
      </ul>
    </div>
    <br><br><br><br><br>
    <div class="bottom-bar">
      <p>Universidad de los Andes</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import VueDrawingCanvas from "vue-drawing-canvas";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

import config from "./config"

const server_ip = config.server_ip

export default {
  components: {
    VueDrawingCanvas,
    PulseLoader
  },
  data() {
    return {
      initialImage: [
        {
          type: "dash",
          from: {
            x: 262,
            y: 154,
          },
          coordinates: [],
          color: "#000000",
          width: 2,
          fill: false,
        },
      ],
      x: 0,
      y: 0,
      image: "",
      line: 2,
      color: "#000000",
      strokeType: "dash",
      lineCap: "square",
      lineJoin: "miter",
      backgroundColor: "#FFFFFF",
      selectedImage: null,
      isImageLoaded: false,
      ButtonPress: false,
      uploadedimage: false,
      searchResults: [],
      loading: false,
    };
  },
  methods: {
    async getSearchResults(image) {
      this.loading = true;
      this.ButtonPress = true;
      const queryPath = image;
      try {

        const response = await axios.post(server_ip + '/search', { query_path: queryPath });
        const results = response.data.results;
        console.log('Similar Images:', results);
        this.searchResults = results;
        this.loading = false;
      } catch (error) {
        console.error('Error retrieving similar images:', error);
      }
    },
    getImageUrl(filename) {
      return server_ip + `/similar_images/${filename}`;
    }
  },
};
</script>


<style>
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  border: #2c3e50;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.bar {
  background-color: #78d3e9;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.leftbar {
  color: rgb(55, 76, 183);
}

.rightbar img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #78d3e9;
  color: #2c3e50;
  padding: 5px;
  text-align: center;
}

.image-list {
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}

.similar-image {
  height: 200px;
  margin: 5px;
  object-fit: cover;
}

.button-container > * {
  margin-top: 15px;
  margin-right: 10px;
}
</style>
